import React, { useEffect, useState } from 'react';
import usePayment from 'hooks/usePayment';
import { OrderBar, BackPage, PaymentOptionCard } from 'components';
import { useHistory } from 'react-router-dom';
import { PaymentMethodPageContent } from 'services/content.js';
import blueCheckIcon from 'assets/blue-check-circle.svg';
import styles from './style.module.css';
import { useSelector } from 'react-redux';
import useQuery from 'hooks/useQuery';
import plusImage from 'assets/plus-green.svg';

const Payment = () => {
  let query = useQuery();
  const history = useHistory();
  const [cards, loadingCards, getCards, , deleteCard] = usePayment();
  const startedJourney = useSelector((state) => state.paymentJourney.started);
  const startedManualJourney = useSelector((state) => state.manualJourney?.started);
  const accountView = query.get('view') === 'account' ? true : false;
  const [deleteView, setDeleteView] = useState(false);
  const [numDeletedCards, setNumDeletedCards] = useState(0);
  const [cardWithError, setCardWithError] = useState({});
  const features = useSelector((state) => state.config.features);

  useEffect(() => {
    if (!startedJourney && !startedManualJourney && !accountView) history.push('/pharmacy/dashboard');
  }, [history, startedJourney, accountView]);

  useEffect(() => {
    getCards();
  }, []);

  const deleteSelectedCard = async (cardToken) => {
    setCardWithError({});
    try {
      await deleteCard(cardToken);
      setNumDeletedCards(numDeletedCards + 1);
    } catch (e) {
      setCardWithError({ token: cardToken, errorMessage: e });
    }
    try {
      await getCards();
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  const displayDeletedCardMessage = () => {
    const deletedCardMessage = [];
    for (var i = 0; i < numDeletedCards; i++) {
      deletedCardMessage.push(
        <div className={styles.messageCard} key={i}>
          <img className={styles.messageIcon} src={blueCheckIcon} alt="check icon" />
          {PaymentMethodPageContent.deletedCardMessageText}
        </div>
      );
    }
    return deletedCardMessage;
  };

  return (
    <>
      {!accountView && <OrderBar currentProgress={startedManualJourney ? 1 : 0} />}
      <BackPage
        onBackClick={() =>
          accountView || startedManualJourney ? history.goBack() : history.push('/pharmacy/dashboard/exemption')
        }
        bplg="5">
        <div className={styles.headingSection}>
          <h1 className={styles.header}>{PaymentMethodPageContent.headingText}</h1>
          <button
            className={styles.link_button}
            href="#"
            onClick={() => {
              setDeleteView(!deleteView);
              setNumDeletedCards(0);
              setCardWithError({});
            }}>
            {deleteView ? PaymentMethodPageContent.doneEditingCardText : PaymentMethodPageContent.editCardText}
          </button>
        </div>
        <p className={styles.intro_text}>
          {accountView ? PaymentMethodPageContent.introTextAccount : PaymentMethodPageContent.introText}
        </p>
        {deleteView && displayDeletedCardMessage()}
        {!loadingCards &&
          cards.map((card, index) => {
            return (
              <PaymentOptionCard
                key={index}
                paymentOption={card}
                accountView={accountView}
                deleteView={deleteView}
                error={card.token === cardWithError.token ? cardWithError.errorMessage : false}
                deleteCard={(token) => deleteSelectedCard(token)}
                manualJourney={startedManualJourney}
              />
            );
          })}
        <div
          className={styles.optionCard}
          tabIndex="0"
          onKeyPress={(event) =>
            event.key === 'Enter' ? history.push('/pharmacy/dashboard/payment/new?view=account') : null
          }
          onClick={() => {
            history.push('/pharmacy/dashboard/payment/new?view=account');
          }}>
          <div className={styles.addPayment}>
            <img src={plusImage} className={styles.plus} alt="add new address" />
            <p className={styles.addPaymentText}>{PaymentMethodPageContent.addCardText}</p>
          </div>
        </div>
      </BackPage>
    </>
  );
};
export default Payment;
